export enum DashboardActionTypes {
    LIST_REQUEST = '@@Dashboard/LIST_REQUEST',
    LIST_SUCCESS = '@@Dashboard/LIST_SUCCESS',
    LIST_ERROR = '@@Dashboard/LIST_ERROR',
}

export interface DashboardUIState {
    readonly loading: boolean
    readonly errors?: string []
}
